import { toRefs, reactive } from 'vue';

const state = reactive({
  quantity: 1,
  medias: null,
  options: null,
  product: null,
  currency: null,
  loading: false,
  mainMedias: null,
  optionRules: null,
  informations: null,
  selectedOptions: {},
});

export default function useProduct() {
  const setQuantity = (quantity) => (state.quantity = quantity);
  const setProduct = (product) => (state.product = product);
  const setMainMedias = (mainMedias) => (state.mainMedias = mainMedias);
  const setMedias = (medias) => (state.medias = medias);
  const setLoading = (loading) => (state.loading = loading);
  const setOptions = (options) => (state.options = options);
  const setOptionRules = (rules) => (state.optionRules = rules);
  const setInformations = (informations) => (state.informations = informations);

  return {
    ...toRefs(state),
    setMedias,
    setProduct,
    setOptions,
    setLoading,
    setQuantity,
    setMainMedias,
    setOptionRules,
    setInformations,
  };
}
